import React, {useContext, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {observer} from "mobx-react";
import {useMount} from "react-use";
import AccountContext from "../../context/account-context";
import {Redirect} from "react-router-dom";
import routerUrls from "../../router-urls";
import {useLocation} from "react-router-dom";
import {LinearProgress, Link} from '@material-ui/core';
import useGetBeiAnData from "../../services/useGetBeiAnData";

const useStyles = makeStyles(theme => ({
  loader: {
    width: 80,
    margin: 'auto 0'
  }
}));

interface LandingPageProps {

}

const LandingPage: React.FC<LandingPageProps> = observer(() => {
  const classes = useStyles();
  const accountContext = useContext(AccountContext);
  const [isLoginVerified, setIsLoginVerified] = useState(false);
  const location = useLocation();
  const {
    text,
    link
  } = useGetBeiAnData();

  useMount(async () => {
    await accountContext.verifyLogin();
    setIsLoginVerified(true)
  });

  if (!isLoginVerified) {
    return <>
      <LinearProgress className={classes.loader}/>
      <Link href={link} target={'_blank'} rel={'noreferrer noopener'}>
        {text}
      </Link>
    </>
  }

  // @ts-ignore
  const from = location.state?.from;

  if (!accountContext.isLogin) {
    // Not logged in -> redirect to login page
    // @ts-ignore
    return <Redirect to={routerUrls.login}/>
  } else {
    if (accountContext.isAdmin) {
      // logged in as admin
      // @ts-ignore
      return <Redirect to={from || routerUrls.adminHome}/>
    } else {
      // logged in as normal user
      // @ts-ignore
      return <Redirect to={from || routerUrls.search}/>
    }
  }
});

export default LandingPage
